import { render, staticRenderFns } from "./Off.vue?vue&type=template&id=33b5d13d&"
import script from "./Off.vue?vue&type=script&lang=js&"
export * from "./Off.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports